import React, {  } from "react";
import { colHeadersPublic } from "./helper";
import { approvedProductsService } from "services/approvedProducts.service";
import ApprovedProducts from "./Components/ApprovedProducts";

const ApprovedProductsPublic = () => {

  const IS_ADMIN = false
  const TITLE_PAGE = "Visa Approved Solutions Directory for EMV 3DS"
  const SEARCHBAR_HELP_TEXT = "Search matches on the following fields: Company, Component, Product or Visa Secure Approval ID."

  return <ApprovedProducts
    api={approvedProductsService.GetPublic}
    apiExport={approvedProductsService.ExportPublic}
    colHeaders={colHeadersPublic}
    helpText={SEARCHBAR_HELP_TEXT}
    isAdmin={IS_ADMIN}
    titlePage={TITLE_PAGE}
  />
};

export default ApprovedProductsPublic;
